import { render, staticRenderFns } from "./PartnerEdit.vue?vue&type=template&id=3346448c&scoped=true"
import script from "./PartnerEdit.vue?vue&type=script&lang=js"
export * from "./PartnerEdit.vue?vue&type=script&lang=js"
import style0 from "./PartnerEdit.vue?vue&type=style&index=0&id=3346448c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3346448c",
  null
  
)

export default component.exports